import { Link } from 'react-router-dom';

export function MobileMenu({ isAuthenticated, isAdmin, isArtist, isAgent, onClose, onLogout }) {
  const close = () => onClose();

  return (
    <div className="md:hidden py-4 border-t border-[#262626]">
      <div className="flex flex-col gap-4">
        {isAgent && <Link to="/agent-dashboard" className="text-sm text-[#A1A1AA] hover:text-white" onClick={close} data-testid="mobile-agent-dashboard">Agent Dashboard</Link>}
        {isArtist && !isAdmin && !isAgent && <Link to="/artist-dashboard" className="text-sm text-[#A1A1AA] hover:text-white" onClick={close}>Artist Dashboard</Link>}
        {!isAgent && <Link to={isAdmin ? "/admin?tab=artists" : "/artists"} className="text-sm text-[#A1A1AA] hover:text-white" onClick={close}>Browse Artists</Link>}
        {isArtist && !isAdmin && !isAgent && <Link to="/studio" className="text-sm font-bold text-lime hover:text-white" onClick={close} data-testid="mobile-nav-studio">STUDIO</Link>}
        {!isArtist && !isAdmin && !isAgent && <Link to="/weekly-specials" className="text-sm text-lime hover:text-white" onClick={close} data-testid="mobile-weekly-specials">Weekly Specials</Link>}
        {!isAdmin && !isAgent && <Link to="/about" className="text-sm text-[#A1A1AA] hover:text-white" onClick={close}>About Us</Link>}
        {!isAdmin && !isAgent && <Link to="/faq" className="text-sm text-[#A1A1AA] hover:text-white" onClick={close} data-testid="mobile-nav-faq">FAQ</Link>}
        {isAuthenticated ? (
          <>
            {!isAdmin && !isArtist && !isAgent && <Link to="/dashboard" className="text-sm text-[#A1A1AA] hover:text-white" onClick={close}>My Orders</Link>}
            {isAdmin && <Link to="/admin" className="text-sm text-[#A1A1AA] hover:text-white" onClick={close}>Admin Panel</Link>}
            <Link to="/settings" className="text-sm text-[#A1A1AA] hover:text-white" onClick={close} data-testid="mobile-settings">Settings</Link>
            <button onClick={onLogout} className="text-sm text-red-400 text-left">Logout</button>
          </>
        ) : (
          <>
            <Link to="/login" className="text-sm text-[#A1A1AA] hover:text-white" onClick={close}>Login</Link>
            <Link to="/register" className="btn-primary text-sm py-2 px-4 text-center" onClick={close}>Sign Up</Link>
          </>
        )}
      </div>
    </div>
  );
}
